import { motion } from "framer-motion";

export function SkeletonCard() {
  return (
    <div className="swipe-card bg-card overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-muted/30 to-muted/60 animate-pulse" />
      
      {/* Shimmer effect */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent"
        initial={{ x: "-100%" }}
        animate={{ x: "100%" }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
      />
      
      {/* Profile info skeleton */}
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <div className="space-y-3">
          <div className="h-8 w-48 bg-white/20 rounded-lg animate-pulse" />
          <div className="h-4 w-32 bg-white/15 rounded animate-pulse" />
          <div className="h-4 w-full bg-white/10 rounded animate-pulse" />
          <div className="flex gap-2">
            <div className="h-6 w-16 bg-white/10 rounded-full animate-pulse" />
            <div className="h-6 w-20 bg-white/10 rounded-full animate-pulse" />
            <div className="h-6 w-14 bg-white/10 rounded-full animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function SkeletonList({ count = 3 }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-center gap-4 p-4 bg-card/50 rounded-xl">
          <div className="w-16 h-16 rounded-full bg-muted animate-pulse" />
          <div className="flex-1 space-y-2">
            <div className="h-5 w-32 bg-muted rounded animate-pulse" />
            <div className="h-4 w-48 bg-muted/70 rounded animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonProfile() {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Header image */}
      <div className="h-80 bg-muted rounded-3xl" />
      
      {/* Name and info */}
      <div className="px-4 space-y-4">
        <div className="h-8 w-48 bg-muted rounded-lg" />
        <div className="h-4 w-32 bg-muted/70 rounded" />
        <div className="h-20 w-full bg-muted/50 rounded-xl" />
        
        {/* Interests */}
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-8 w-20 bg-muted/50 rounded-full" />
          ))}
        </div>
      </div>
    </div>
  );
}
